import { useQuery } from "@apollo/client/react";
import GET_ALL_MONITOR_EVENTS from "../../queries/aml/getAllMonitorEvents";
import type { MonitorEventsResponse } from "../../../models/AmlMonitoringEvents";

export const useAllMonitorEvents = (
  sortDirection: "ASC" | "DESC",
  createdFrom?: Date,
  createdTo?: Date,
  isHandled?: boolean,
  eventTypes?: Array<string>,
  skip?: number,
  take?: number,
  sortBy?: "CREATED_AT" | "ISSUER_CLIENT_IDENTIFIER" | "ISSUER_CLIENT_NAME"
) => {
  const { data, error, loading, refetch } = useQuery<{
    clientmonitoringevents: MonitorEventsResponse;
  }>(GET_ALL_MONITOR_EVENTS, {
    variables: {
      sortDirection: sortDirection,
      createdFrom: createdFrom,
      createdTo: createdTo,
      isHandled: isHandled,
      eventTypes: eventTypes,
      skip: skip,
      take: take,
      sortBy: sortBy,
    },
  });
  return {
    monitorEvents: data?.clientmonitoringevents,
    error,
    loading,
    refetch,
  };
};
